import axios from "axios";
import router from "@/router";
import { ElMessage, ElLoading } from "element-plus";

let ConfigBaseURL = process.env.VUE_APP_URL;
// let loadingInstance = null; //这里是loading
let loadingInstance = {
  close: () => { } // 空
};
//使用create方法创建axios实例
const Service = axios.create({
  timeout: 5 * 60 * 1000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: "post",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

// 添加请求拦截器
Service.interceptors.request.use((config) => {
  // loadingInstance = ElLoading.service({
  //   lock: true,
  //   text: "loading...",
  // });
  loadingInstance = loadingInstance;
  let token = localStorage.getItem(
    `token:${JSON.parse(sessionStorage.getItem("userInfo"))?.id}`
  );
  if (token) {
    config.headers["token"] = token; // token
  }
  return config;
});
// 添加响应拦截器
Service.interceptors.response.use(
  (response) => {
    loadingInstance.close();
    const { data, config } = response;

    if (config.responseType === "blob") {
      let flag = false;
      if (data.type === "application/json") {
        // const reader = new FileReader()
        // reader.readAsText(data, 'utf-8')
        // reader.onloadend = function () {
        //     let dataJson = JSON.parse(reader.result);
        //     dataJson.messages && dataJson.messages.forEach(item => {
        //         ElMessage({
        //             message: item.message,
        //             type: "error",
        //             duration: 3 * 1000,
        //         });
        //     })
        // flag = true
        // };

        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsText(data, "utf-8");
          reader.onload = () => {
            try {
              const dataJson = JSON.parse(reader.result);
              if (dataJson.code !== "S200") {
                dataJson.messages &&
                  dataJson.messages.forEach((item) => {
                    ElMessage({
                      message: item.message,
                      type: "error",
                      duration: 3 * 1000,
                    });
                  });
                reject(new Error("下载错误"));
              } else {
                resolve(response.data);
              }
            } catch (error) {
              reject(error);
            }
          };
          reader.onerror = (error) => {
            reject(error);
          };
        });
      } else {
        let name = config.fileName;
        const link = document.createElement("a");
        let blob = new Blob([data], {
          type: data.type,
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        flag = false;
      }
      return flag ? Promise.reject("下载错误") : Promise.resolve();
    }
    if (data.code === "S200") {
      return data.data;
    } else if (data.code === "6001") {  // 处理6001的情况
      ElMessage({
        message: "密码强度不足，请修改密码",
        type: "warning",
        duration: 4000
      });
      return Promise.reject(data);  // 直接返回整个data对象
    } else if (data.code === "2002" || data.code === "2009") {
      let msg = data.messages[0].message;
      ElMessage({
        message: msg,
        type: "error",
        duration: 3 * 1000,
        onClose: () => {
          localStorage.clear();
          let code = sessionStorage.getItem("code");
          const url = `/Login?code=${code}`;
          router.push(url);
        },
      });
      return Promise.reject(data.messages);
    } else if (data.code === "2055" || data.code === "2056" || data.code === "2057") { //中煤保单关联
      return Promise.resolve(data)
    }
    else {
      if (!config.noErrorMsg) {
        data.messages.forEach((msg) => {
          ElMessage({
            message: msg.message,
            type: "error",
            duration: 4 * 1000,
          });
        });
      }
      return Promise.reject(data.messages);
    }
  },
  (error) => {
    console.log("TCL: error", error);
    ElMessage({
      message: error.message,
      type: "error",
      duration: 3 * 1000,
    });
    loadingInstance.close();
    return Promise.reject(error);
  }
);

export default Service;
